export default __webpack_public_path__ + "static/media/home-select.3c944f15.svg";